export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7133.60e69a02.jpg";